import 'angular';

import { MailchimpStates }        from './mailchimp.states.ajs';
import { MailChimpSettingsCtrl }  from './mailchimp.settings';

angular.module('workshop.mailchimp', [])
.controller('MailChimpSettingsCtrl', MailChimpSettingsCtrl)

.config(MailchimpStates);